module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("This is a work of fiction. All the characters and events portrayed in this novel are either fictitious or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SUN OF SUNS: VIRGA, BOOK ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Copyright © 2006 by Karl Schroeder")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("All rights reserved, including the right to reproduce this book, or portions thereof, in any form.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Edited by David G. Hartwell")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("A Tor Book"), _c('br'), _vm._v("Published by Tom Doherty Associates, LLC"), _c('br'), _vm._v("175 Fifth Avenue"), _c('br'), _vm._v("New York, NY 10010")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.tot.com",
      "target": "_blank"
    }
  }, [_vm._v("www.tor.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Tor"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of Tom Doherty Associates, LLC.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Schroeder, Karl, 1962–"), _c('br'), _vm._v("    Sun of suns / Karl Schroeder.—1st ed."), _c('br'), _vm._v("         p. cm. — (Virga ; bk. 1)"), _c('br'), _vm._v("    “A Tom Doherty Associates book.”"), _c('br'), _vm._v("ISBN-13: 978-0-765-31543-4"), _c('br'), _vm._v("ISBN-10: 0-765-31543-2"), _c('br'), _vm._v("I. Title"), _c('br'), _vm._v("PR9199.3.S269S86  2006"), _c('br'), _vm._v("813'.6—dc22                                                                  2006005929")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First Edition: October 2006")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("0   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49af5c96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 75
// module chunks = 0